/*
 * @FilePath: \uni-preset-vue-vite\src\model\global\index.js
 * @Date: 2022-10-01 21:51:11
 * @Author: itmanyong@gmail.com
 * @LastEditors: guoye
 * @LastEditTime: 2025-07-15 16:27:45
 * @Description: 全局模块
 */
function setup() {
  //   const i = ref(0)
  //   const edit = (val) => {
  //     i.value = val
  //   }
  //   const newi = computed(() => {
  //     return i.value
  //   })
  // const { success, warning } = useToast()

  let state = reactive({
    pina_temporaryData: null, // 临时信息
    pina_certificationInfo: {}, // 实名认证信息
    pina_merchatInfo: {}, // 商户信息
    pina_merchatInfo_qy: null, // 企业信息
    pina_terminalInfo: null, // 终端信息
    pina_displayMerchatInfo: null, // 返显的商户信息
    pina_orgDictInfo: null, // org 配置
    pina_orgInfo: {}, // orgInfo 信息
    pina_systemInfo: {}, // 原生系统信息
    pina_faceInfo: {}, //人脸识别信息
    pina_faceCount: 0, // 人脸次数
    pina_certificationStepInfo: {} // 进件改件步骤 信息
  })

  const Auth = {
    setToken(val) {
      // console.log(38, 'val-->', val)
      state.pina_systemInfo.token = val
    },
    isLogin() {
      return !!state.pina_systemInfo.token
    }
  }

  return {
    //   i,
    //  newi,
    //  edit,
    ...toRefs(state),
    Auth
  }
}

const option = {
  // 配置持久化
  persist: {
    //   paths: ['num'],
    storage: sessionStorage,
    //  key: 'my_num',
    paths: [
      // 'i',
      'pina_temporaryData',
      'pina_certificationInfo',
      'pina_merchatInfo',
      'pina_merchatInfo_qy',
      'pina_displayMerchatInfo',
      'pina_terminalInfo',
      'pina_orgInfo',
      'pina_orgDictInfo',
      'pina_systemInfo',
      'pina_faceInfo',
      'pina_faceCount',
      'pina_certificationStepInfo'
    ]
  }
  //   persist: true,
}

export { option, setup }
